import React from 'react';
import Logos from './Logos/';
import Carousel from './Carousel/';

const Clients = (props) => {

  return(
    <div>
      <Carousel lang={props.lang} items={props.items.installations}/>
      <Logos lang={props.lang} items={props.items.clients}/>
    </div>
  )

}

export default Clients;